var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 56.693,
    height: 56.693,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m35.021 8.568.547-.819.537-.808 1.209-1.813a.485.485 0 1 0-.807-.537l-1.295 1.944-.545.817-.553.828a15.961 15.961 0 0 0-5.768-1.06c-2.061 0-4.014.381-5.766 1.06l-.55-.828-.545-.817-1.297-1.945a.486.486 0 0 0-.807.537l1.208 1.813.539.808.547.819c-4.115 1.916-6.898 5.546-6.898 9.701h27.142c0-4.154-2.783-7.784-6.898-9.7zm-12.489 5.823a1.454 1.454 0 1 1-.003-2.907 1.454 1.454 0 0 1 .003 2.907zm11.631 0a1.453 1.453 0 1 1 0-2.906 1.453 1.453 0 0 1 0 2.906zM14.986 20.208h-.209V41.535a3.072 3.072 0 0 0 3.069 3.07h2.216a2.904 2.904 0 0 0-.116.807v6.141a2.91 2.91 0 0 0 5.817 0v-6.141c0-.279-.043-.551-.115-.807h5.4a2.904 2.904 0 0 0-.115.807v6.141c0 1.605 1.303 2.908 2.908 2.908s2.908-1.303 2.908-2.908v-6.141a2.91 2.91 0 0 0-.115-.807h2.215a3.073 3.073 0 0 0 3.07-3.07V20.208H14.986zM9.929 20.208a2.908 2.908 0 0 0-2.908 2.909v12.439a2.909 2.909 0 0 0 5.816 0v-12.44a2.907 2.907 0 0 0-2.908-2.908zM46.767 20.208a2.907 2.907 0 0 0-2.908 2.909v12.439a2.908 2.908 0 0 0 5.814 0v-12.44a2.906 2.906 0 0 0-2.906-2.908z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.488111c0d1cf1e664bbd01db39f15738.svg";
export { ForwardRef as ReactComponent };